export interface Position {
  id: number;
  position: number;
}

export enum APIFileStatus {
  OK = 'ok',
  ERROR = 'error',
  PENDING = 'pending',
}

export type APIFileStatusValues = `${APIFileStatus}` | null;
